<template>
	<div>
		<v-dialog v-model="dialog_business_name" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
				<v-card-title class="title noshadow" v-if="header">
					<v-icon class="mr-3" v-if="header == 'Deactivate Business?'">error_outline</v-icon>
					{{ header }}
				</v-card-title>
        	  	<v-card-text>
        	  		<v-form data-vv-scope="businessName">
        	  			<!-- <v-text-field
        	  			    label="Type Yes to continue"
        	  			    placeholder=" " 
        	  			    v-model="confimationFlag"
        	  			></v-text-field> -->
						  <v-text-field
        	  			    :label="header == 'Change Backup Drive' ? 'Type yes to continue' : 'Type business name to continue'"
        	  			    placeholder=" " 
        	  			    v-model="confimationFlag"
        	  			></v-text-field>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog()">cancel</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_matchBusinessName">continue</v-btn>
		        </v-card-actions>
	        	</v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	props:['header'],
	data(){	
		return{
			dialog_business_name: false,
			confimationFlag:''
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_business_name = true;
		},
		closeDialogWeb: function () {
			this.dialog_business_name = false;
		},
		fn_matchBusinessName: function () {
			// if(this.confimationFlag.trim().toLowerCase() != 'yes'){
			// 	this.showToast('Please type yes to continue');
			// }
			if(this.header == 'Change Backup Drive'){
				if(this.confimationFlag.trim().toLowerCase() != 'yes'){
					this.showToast('Please type yes to continue');
				}
				else{
					this.confimationFlag = '';	
					this.$parent.fn_openDialogConfirmation(true);
				}
				
			}
			else{
				if(this.confimationFlag.trim().toLowerCase() != this.$root.CurrentBusiness.BusinessName.trim().toLowerCase()){
					this.showToast('Please type your business name to continue');
				}
				else{
					this.confimationFlag = '';	
					this.$parent.fn_openDialogConfirmation(true);
				}
			}
			// else if(this.confimationFlag.trim().toLowerCase() != this.$root.CurrentBusiness.BusinessName.trim().toLowerCase()){
			// 	this.showToast('Please type your business name to continue');
			// }
			// else{
			// 	this.confimationFlag = '';	
			// 	this.$parent.fn_openDialogConfirmation(true);
			// }
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_business_name.vue